import { render, staticRenderFns } from "./PatientCapabilityState.vue?vue&type=template&id=16feedb2&scoped=true&"
import script from "./PatientCapabilityState.vue?vue&type=script&lang=js&"
export * from "./PatientCapabilityState.vue?vue&type=script&lang=js&"
import style0 from "./PatientCapabilityState.vue?vue&type=style&index=0&id=16feedb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16feedb2",
  null
  
)

export default component.exports